export default "__VITE_ASSET__Cllgk6s7__"